cv.EmailView = Marionette.LayoutView.extend({
  template: cv.Templates["email/view"],

  regions: {},

  events: {
    "change #default_template": "changeTemplate",
    "click .send": "sendMessage",
  },

  initialize: function (options) {
    this.options = _.extend(this.options, options);

    console.log("PageView initialized");
  },

  templateHelpers: function () {
    return {};
  },

  sendMessage: function (e) {
    e.preventDefault();
  },

  changeTemplate: function (e) {
    if ($(e.currentTarget).val() == "template1") {
      this.$("#message_content").val(
        "Dear friends and family,\n" +
          "\n" +
          "I am excited to be running in the New York City Marathon with Team Amazing Nonprofit to raise funds to help kids unlock the power of play, everywhere.\n" +
          "\n" +
          "Amazing Nonprofit believes that having access to a healthy life is a right and not a privilege, yet over 4 million kids are classified as physically inactive and engage in no sport activity throughout the year – over 30% of those children come from households where the average income is under $25k a year. Together we can change this reality.\n" +
          "\n" +
          "Can you help me serve more kids by donating to my fundraising page today? Every donation makes a difference.\n"
      );
    }
    if ($(e.currentTarget).val() == "template2") {
      this.$("#message_content").val(
        "Hi there –\n" +
          "\n" +
          "I’m half-way through my fundraising goal! It’s been a lot of fun to raise awareness for this issue, and I’m so grateful for all of you who have already donated. \n" +
          "\n" +
          "Please join me in supporting this cause to improve the lives of people affected by this disease.\n"
      );
    }
    if ($(e.currentTarget).val() == "template3") {
      this.$("#message_content").val(
        "As you may know, I am a member of the Children’s Foundation. This month, I am fundraising for their mission to empower kids to make positive life choices. The funds raised will fund year-round out-of-school-time and social-emotional learning programs for New York’s most deserving youth.\n" +
          "\n" +
          "I hope you’ll support the cause!\n"
      );
    }
  },

  onAttach: function () {},

  onDestroy: function () {},
});
